import { useCallback } from 'react'
import { useCalculateDistance } from './useCalculateDistance'
import { useGeneratePoints } from './useGeneratePoints'
import { useDispatch } from 'react-redux'
import { addPoints } from '../../store/appSlice'
import supabase from '../utils/supabase'

interface Location {
  lat: number
  long: number
  country: string
}

interface answerLocation {
  lat: number
  long: number
  code: string
  level: number
}

interface GameResults {
  distance: number
  correct: boolean
  points: Points
}

interface Points {
  correctness: number
  closeness: number
  level: number
}

export function useCountryMatch() {
  const dispatch = useDispatch()

  const { calculateDistance } = useCalculateDistance()
  const { calcPoints } = useGeneratePoints()

  const checkCountryMatch = useCallback(
    async (
      location: Location,
      answer: answerLocation
    ): Promise<GameResults> => {
      const languageDataSupabase = await supabase
        .from('language_data')
        .select('*')
      if (!languageDataSupabase.data) throw new Error('No language data found')
      const languageData = languageDataSupabase.data

      const matchingRow = languageData.find((row) => row.code === answer.code)
      const gameResults = {
        distance: 0,
        correct: false,
        points: {
          correctness: 0,
          closeness: 0,
          level: 0,
        },
      }

      //check if country is correct
      if (
        matchingRow &&
        matchingRow.all_countries.some((item: string) =>
          location.country.includes(item)
        )
      ) {
        gameResults.correct = true
      } else {
        const distance = calculateDistance({
          lat1: location.lat,
          lon1: location.long,
          lat2: answer.lat,
          lon2: answer.long,
        })
        gameResults.distance = distance
      }

      gameResults.points = calcPoints({
        correct: gameResults.correct,
        distance: gameResults.distance,
        level: answer.level,
      })

      //add points to redux
      const totalPoints =
        gameResults.points.correctness +
        gameResults.points.closeness +
        gameResults.points.level
      dispatch(addPoints(totalPoints))

      return gameResults
    },
    []
  )

  return { checkCountryMatch }
}
